<!-- General statistics for current campaign -->
<section>
  <h2 class="p-text-h3 tw-mb-5">{{ 'campaign.campaignDetails' | translate }}</h2>

  <div class="tw-rounded-10px tw-border tw-border-divider">
    <div
      class="tw-grid tw-divide-y tw-divide-divider md:tw-grid-cols-3 md:tw-divide-x md:tw-divide-y-0"
    >
      @for (col of campaignDetails; track col) {
        <div>
          <ul class="tw-mb-0 tw-list-none tw-p-8" [class]="col.wrapperClass">
            @for (item of col.children; track item) {
              <li class="tw-text-black">
                <label class="p-text-label tw-mb-0">{{ item.name | translate }}</label>
                @if (item.isCurrency) {
                  <div>
                    {{ item.value | numberSuffix }}
                  </div>
                } @else {
                  <div>{{ item.value }}</div>
                }
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
</section>
